import { Search } from "lucide-react";
import type { HTMLAttributes, ReactNode } from "react";

export function BuilderReportRail({
  children,
  fill = false,
}: {
  children: ReactNode;
  fill?: boolean;
}) {
  return (
    <aside
      className={`${
        fill
          ? "h-full w-full"
          : "w-56 min-w-56 shrink-0 border-r border-border/60"
      } space-y-2 overflow-y-auto bg-card p-3`}
    >
      {children}
    </aside>
  );
}

export function BuilderReportRailSearch({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div className="flex items-center gap-1 rounded-lg bg-muted px-2.5 py-1.5">
      <Search size={11} className="text-muted-foreground/70" />
      <input
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder="Find"
        className="w-full bg-transparent outline-none"
        style={{ fontSize: 11.5 }}
      />
    </div>
  );
}

export function BuilderReportRailSection({
  title,
  children,
}: {
  title: string;
  children?: ReactNode;
}) {
  return (
    <div>
      <div
        className="mb-1 mt-2 uppercase tracking-wider text-muted-foreground/70"
        style={{ fontSize: 9 }}
      >
        {title}
      </div>
      {children}
    </div>
  );
}

interface BuilderReportRailItemProps extends HTMLAttributes<HTMLDivElement> {
  active?: boolean;
}

export function BuilderReportRailItem({
  active = false,
  className = "",
  children,
  ...props
}: BuilderReportRailItemProps) {
  return (
    <div
      {...props}
      className={`group flex w-full items-center gap-1.5 rounded-lg px-2 py-1.5 text-left ${
        active
          ? "bg-muted font-medium text-foreground"
          : "text-muted-foreground hover:bg-muted/50"
      } ${className}`}
      style={{ fontSize: 12, ...props.style }}
    >
      {children}
    </div>
  );
}
